<template>
  <div class="section section--wikipedia" v-if="articles">
    <div>
      <h2>Nearby on Wikipedia</h2>
      <ul class="wikipedia-articles">
        <li v-for="article in articles" :key="article.pageid" class="wikipedia-article">
          <h3>
            <a :href="article.content_urls.desktop.page" target="_blank">{{ article.displaytitle }}</a>
            <span class="distance"> {{ article.distance | numberFormatted({useFeet: true, locale: $t.locale}) }} {{ $t('units.mi') }} away</span>
          </h3>
          <p>{{ article.extract }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import axios from 'axios';

const { encode } = require('wiki-article-name-encoding');

export default {
  data() {
    return {
      articles: null,
      loading: true,
    };
  },
  computed: {
    ...mapState(['address', 'location']),
  },
  methods: {
    async findNearby() {
      const response = await axios.get('/.netlify/functions/wikipedia', {
        params: {
          latitude: this.location.latitude,
          longitude: this.location.longitude,
        },
      });
      const articlePromises = [];
      response.data.articles.forEach((item) => {
        articlePromises.push(this.loadArticle(item));
      });
      const articles = await Promise.all(articlePromises);
      this.articles = articles.sort((a, b) => a.distance - b.distance);
      // console.log(this.articles);
    },
    async loadArticle(item) {
      let article = null;
      try {
        const response = await axios.get(`https://en.wikipedia.org/api/rest_v1/page/summary/${encode(item.title)}`);
        article = response.data;
        article.distance = item.distance;
      } catch {
        return article;
      }
      return article;
    },
  },
  watch: {
    location() {
      this.findNearby();
    },
  },
};
</script>
